import {Component, EventEmitter, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {InputBase} from '../input-base';

@Component({
  selector: 'cmp-input-date',
  template: `<label class="m-1" *ngIf="_label">{{_label}}</label>

<input
  [attr.maxlength]="_maxlenght || null"
  [attr.minlength]="_minlength || null"
  [class]="classCustom"
  [disabled]="isDisabled || null"
  [id]="nameId"
  [ngModel]="_model"
  (ngModelChange)="date = $event"
  (click)="d.toggle()"
  ngbDatepicker #d="ngbDatepicker"
  [placeholder]="_placeholder">


<small *ngIf="(textDetail && viewTextDetail ) || viewMesageDinamicValidation"
       class="form-text text-center text-{{colorTextDetail}}">{{textDetail}}
</small>
`,
  styles: [``]
})
export class InputDateComponent extends InputBase implements OnInit, OnChanges {

  @Output() changeModel = new EventEmitter();
  _model: any;

  constructor() {
    super();
  }

  ngOnInit() {
  }


  formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }
    const obj = {
      year: Number(year),
      month: Number(month),
      day: Number(day)
    };
    return obj;
  }


  set date(value: any) {
    if (JSON.stringify(this._model) !== JSON.stringify(value)) {
      const aux = `${value.year}-${value.month}-${value.day}`;
      if (this.control) {
        this.control.setValue(Date.parse(aux));
      } else {
        this.model = Date.parse(aux);
      }
      this.outputModel();
    }
  }

  get classCustom() {
    let retorno = 'form-control form-control-sm ';
    if (this.onClass) {
      retorno += this.onClass;
    }
    if (this.control) {
      retorno += this.control && this.control.valid ? 'is-valid' : 'is-invalid';
    }
    return retorno;
  }

  ngOnChanges(changes: SimpleChanges): void {
    let retorno = this.model;
    if (this.control) {
      retorno = this.control.value;
    }
    this._model = this.formatDate(retorno);
  }
}
